import { useTranslation } from '@/i18n';
import { FileOption } from '@moneyforward/ap-frontend-components/dist/es/molecules/FileList/type';
import { useMemo } from 'react';

export const useFileOptions = (
  handleOptionChecked: FileOption['onChange'],
  showAiSuggest = false
) => {
  const { t } = useTranslation();
  const options = useMemo((): TFileOption[] => {
    const opts: TFileOption[] = [
      {
        label: t('received_invoice.uploader.ai_ocr'),
        name: 'do_ai_ocr',
        tooltip: t('received_invoice.uploader.ai_ocr_tooltip'),
        // AI OCR is required by AI Suggest, so it is auto-checked and locked
        // (disabled) while AI Suggest is on, with an explanatory tooltip.
        ...(showAiSuggest && {
          disabledTooltip: t(
            'received_invoice.uploader.ai_ocr_disabled_tooltip'
          ),
          disabled: (optionsChecked) => !!optionsChecked['do_ai_suggest'],
        }),
        onChange: handleOptionChecked,
        defaultChecked: true,
      },
    ];
    if (showAiSuggest) {
      opts.push({
        label: t('received_invoice.uploader.ai_suggest'),
        name: 'do_ai_suggest',
        tooltip: t('received_invoice.uploader.ai_suggest_tooltip'),
        onChange: handleOptionChecked,
        defaultChecked: false,
        // AI Suggest is opt-in, so the check-all defaults to unchecked.
        defaultCheckAll: false,
      });
    }
    return opts;
  }, [t, handleOptionChecked, showAiSuggest]);
  return options;
};

export type TFileOption = FileOption & { defaultChecked?: boolean };
